var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressPinStaffDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0098 10.9219C20.8949 10.9221 24.1854 13.0926 24.1855 17.2305C24.1855 19.9833 22.1302 22.8867 18.0098 25.9219C13.8892 22.8866 11.833 19.9834 11.833 17.2305C11.8331 13.0924 15.1245 10.9219 18.0098 10.9219ZM18.0088 12.6865C16.3059 12.6866 13.5968 13.9219 13.5967 17.2305C13.5967 19.1275 15.1148 21.3513 18.0088 23.6895C20.9029 21.3512 22.4209 19.1364 22.4209 17.2305C22.4208 13.9218 19.7117 12.6865 18.0088 12.6865ZM18.0088 15.334C18.9834 15.334 19.7734 16.124 19.7734 17.0986C19.7732 18.0731 18.9833 18.8633 18.0088 18.8633C17.0384 18.8632 16.2444 18.069 16.2441 17.0986C16.2441 16.1281 17.0382 15.334 18.0088 15.334Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPinStaffDetail);
export default __webpack_public_path__ + "static/media/address_pin_staff_detail.c60009200797fab2e837678c2e2b9744.svg";
export { ForwardRef as ReactComponent };